import React, { useState, useMemo } from "react";
import { SectionTitle } from "./section-title";
import { CURRENT_LIBRARIES } from "../data/current_libraries";
import { REGIONS } from "../data/regions";

/**
 * RegionSection
 *
 * Componente que muestra las bibliotecas participantes organizadas por regiones y departamentos.
 * Permite alternar (toggle) entre regiones de dos grupos (Grupo1 y Grupo2),
 * mostrando las bibliotecas correspondientes a la región seleccionada.
 *
 * @component
 * @example
 * return (
 *   <RegionSection />
 * )
 */
export const RegionSection = () => {
    const libraries = CURRENT_LIBRARIES;
    const [currentRegionId, setCurrentRegionId] = useState("");
    const [currentRegionData, setCurrentRegionData] = useState(
        libraries.filter((library) => library.regionId === currentRegionId)
    );

    const departments = useMemo(() => {
        return [...new Set(currentRegionData.map(item => item.Departamento))];
    }, [currentRegionData]);

    const grupo1 = REGIONS?.grupo1;
    const grupo2 = REGIONS?.grupo2;

    /**
     * Función que carga los datos de una región seleccionada.
     * Si se hace clic en la misma región activa, se desactiva (toggle).
     *
     * @param {string} region - ID de la región seleccionada
     */
    const loadRegionData = (region) => {
        if (region === currentRegionId) {
            setCurrentRegionId("");
            setCurrentRegionData([]);
        } else {
            setCurrentRegionId(region);
            setCurrentRegionData(libraries.filter((library) => library.regionId === region));
        }

    };

    return (
        <section className="p-3">
            <SectionTitle title={"Bibliotecas participantes"} />
            <div className="row">
                <div className="col-12 col-lg-6">
                    <h2 className="text-center  text-lg-left secondary-font font-weight-bold secondary-inverse--color">Grupo1</h2>
                    {grupo1.map((region, i) => {
                        return (
                            <>
                                <button
                                    key={i}
                                    className={`w-100 region-label p-2 my-1 secondary-font font-weight-bold text-center ${region?.id === currentRegionId ? "current-region" : ""}`}
                                    style={{
                                        borderRadius: "1rem",
                                        backgroundColor: region?.color?.bg,
                                        color: region?.color?.text,
                                    }}
                                    onClick={() => { loadRegionData(region?.id) }}
                                >
                                    {region.name}
                                </button>
                                {region?.id === currentRegionId ? (
                                    <div className="mt-3">
                                        {
                                            departments.map((area, i) => {
                                                return (
                                                    <div key={`gr1-departamento-${area}`} className="list px-3">
                                                        <h3 className="text-16 secondary-font font-weight-bold">{area}</h3>
                                                        <ul
                                                            className={`list overflow-auto p-3`}
                                                            style={{
                                                                maxHeight: "300px",
                                                                overflow: "auto",
                                                                transition: "height 0.5s",
                                                            }}
                                                        >
                                                            {currentRegionData?.map((item, j) => {
                                                                if (item?.Departamento === area) {
                                                                    return (
                                                                        <li key={j} className="onbackground-primary--color">
                                                                            {j + 1}. {item?.libraryName}
                                                                        </li>
                                                                    )
                                                                }
                                                            })}
                                                        </ul>

                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </>
                        );
                    })}
                </div>
                <div className="col-12 col-lg-6">
                    <h2 className="text-center  text-lg-left secondary-font font-weight-bold secondary-inverse--color">Grupo2</h2>
                    {grupo2.map((region, i) => {
                        return (
                            <>
                                <button
                                    key={i}
                                    className={`w-100 region-label p-2 my-1 secondary-font font-weight-bold text-center ${region?.id === currentRegionId ? "current-region" : ""}`}
                                    style={{
                                        borderRadius: "1rem",
                                        backgroundColor: region?.color?.bg,
                                        color: region?.color?.text,
                                    }}
                                    onClick={() => { loadRegionData(region?.id) }}
                                >
                                    {region.name}
                                </button>
                                {region?.id === currentRegionId ? (
                                    <div className="mt-3">
                                        {
                                            departments.map((area, i) => {
                                                return (
                                                    <div key={`gr1-departamento-${area}`} className="list px-3">
                                                        <h3 className="text-16 secondary-font font-weight-bold">{area}</h3>
                                                        <ul
                                                            className={`list overflow-auto p-3`}
                                                            style={{
                                                                maxHeight: "300px",
                                                                overflow: "auto",
                                                                transition: "height 0.5s",
                                                            }}
                                                        >
                                                            {currentRegionData?.map((item, j) => {
                                                                if (item?.Departamento === area) {
                                                                    return (
                                                                        <li key={j} className="onbackground-primary--color">
                                                                            {j + 1}. {item?.libraryName}
                                                                        </li>
                                                                    )
                                                                }
                                                            })}
                                                        </ul>

                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
